export function getPropertyByKey(array, key, value, returnKey) {
    const item = array.find(element => element[key] == value);
    return item ? item[returnKey] : null;
}